import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteRule } from '../features/rules/ruleSlice';
// import { getAutomationRules, setAutomationRules } from '../features/rules/ruleSlice';
import { reset } from '../features/rules/ruleSlice';
import { Container, Col, Row, Form, Modal, Button, ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaWrench, FaPlusCircle } from 'react-icons/fa';
import toastConfig from '../app/toast-config';

function Rules({ websocket, isClientSet, getControlMode }) {
    const { user } = useSelector((state) => state.auth);
    const clientId = localStorage.getItem('clientId');
    const { currentDevice } = useSelector((state) => state.deviceData);
    const { rules, isLoading } = useSelector((state) => state.rulesData);
    const [rulesData, setRulesData] = useState([ ...rules ]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const actions = ["Watering", "Cooling", "Lights"];
    const sources = {
        watering: ["Soil moisture", "Scheduled"],
        cooling: ["Temperature", "Scheduled"],
        lights: ["Light intensity", "Scheduled"]
    }
    const hours = Array.from({length: 24}, (_, i) => {
        if(i / 10 < 1) return `0${i}`
        else return `${i}`
    })
    
    const minutes = Array.from({length: 60}, (_, i) => {
        if(i / 10 < 1) return `0${i}`
        else return `${i}`
    })

    const start = 50;
    const stop = 200;
    const step = 10; 
    const wateringAmounts = Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step))
    // let sourcesDropdown = sources.watering;
    const dispatch = useDispatch();

    const getRules = () => {
        if(user && currentDevice && currentDevice !== null) {
            if(currentDevice.id && currentDevice.id !== "") {
                
                const json = {
                    action: "get_rules",
                    deviceId: currentDevice.id,
                    userId: user._id
                }
                if (websocket?.readyState === WebSocket.OPEN) {
                    console.log(`Seding request for rules for device ${currentDevice.id} to the server.`);
                    websocket.send(JSON.stringify(json));
                }
                return;
            }
        }
        console.log("USER, CURRENT DEVICE OR CLIENT MISSING!");
    }

    const setRules = () => {
        if(user && currentDevice && currentDevice !== null) {
            if(currentDevice.id && currentDevice.id !== "") {
                const json = {
                    action: "set_rules",
                    deviceId: currentDevice.id,
                    userId: user._id,
                    rules: rulesData
                }
                if (websocket?.readyState === WebSocket.OPEN) {
                    console.log(`Seding new rules data for device ${currentDevice.id} to the server.`);
                    websocket.send(JSON.stringify(json));
                }
                return;
            }
        }
        console.log("USER, CURRENT DEVICE OR CLIENT MISSING!");
    }

    // useEffect(() => {
    //     console.log(`Rules on page load: ${rules.length}`);
    //     // console.log(JSON.stringify(rules));
    //     return () => {
    //         dispatch(reset());
    //     }
    // }, [])

    useEffect(() => {
        console.log("Get rules on currentDevice or websocket change");
        getRules();
        console.log("Get control mode on currentDevice or websocket change.");
        getControlMode();
    }, [currentDevice, websocket, isClientSet])

    // useEffect(() => {
    //     console.log("Get control mode on currentDevice or websocket change.");
    //     getControlMode();
    // }, [currentDevice])

    useEffect(() => {
        console.log("Setting rulesData on rules change");
        // console.log(JSON.stringify(rules));
        setRulesData([ ...rules ]);
    }, [rules])

    // useEffect(() => {
    //     console.log("rulesData changed");
    //     console.log(JSON.stringify(rulesData));
    // }, [rulesData])

    const updateRules = () => {
        let data = [ ...rulesData ];
        // data = data.map(rule => {
        //     return {
        //         ...rule,
        //         treshold_min: rule.treshold_min ? parseFloat(rule.treshold_min) : undefined,
        //         treshold_max: rule.treshold_max ? parseFloat(rule.treshold_max) : undefined
        //     }
        // });
        if(validateRules(data)) {
            console.log(data);
            const json = {
                action: "update_rules",
                deviceId: currentDevice.id,
                rules: data
            }
            setRules(json);
            dispatch(reset());
            handleClose();
        }
        else {
            console.log("Rules not updated - input data validation failed.");
        }
    }

    const validateRules = (data) => {
        const minHour = 0;
        const maxHour = 23;
        const minMinute = 0;
        const maxMinute = 59;
        let min, max, errorCounter = 0;
        
        data.forEach(rule => {
            switch (rule.action) {
                case "Watering":
                    switch (rule.source) {
                        case "Soil moisture":
                            min = 0;
                            max = 4095;
                            if(rule.treshold < min || rule.treshold > max) {
                                toast.info(`Soil moisture treshold must be between ${min} and ${max}.`, toastConfig);
                                errorCounter++;
                            }
                            min = 50;
                            max = 200;
                            if(rule.amount < min || rule.amount > max) {
                                toast.info(`Watering amount must be between ${min} and ${max} ml.`, toastConfig);
                                errorCounter++;
                            }
                        break;
                        case "Scheduled":
                            min = 50;
                            max = 200;
                            if(rule.amount < min || rule.amount > max) {
                                toast.info(`Watering amount must be between ${min} and ${max} ml.`, toastConfig);
                                errorCounter++;
                            }
                            if(rule.start.minute < minMinute || rule.start.minute > maxMinute || rule.start.hour < minHour || rule.start.hour > maxHour) {
                                toast.info(`Scheduling start time invalid.`, toastConfig);
                                errorCounter++;
                            }
                        break;
                    }
                break;
                case "Cooling":
                    switch (rule.source) {
                        case "Temperature":
                            min = 0;
                            max = 50;
                            if(rule.treshold < min || rule.treshold > max) {
                                toast.info(`Temperature treshold must be between ${min} and ${max} ℃.`, toastConfig);
                                errorCounter++;
                            }
                        break;
                        case "Scheduled":
                            if(rule.start.minute < minMinute || rule.start.minute > maxMinute || rule.start.hour < minHour || rule.start.hour > maxHour) {
                                toast.info(`Scheduling start time invalid.`, toastConfig);
                                errorCounter++;
                            }
                            if(rule.end.minute < minMinute || rule.end.minute > maxMinute || rule.end.hour < minHour || rule.end.hour > maxHour) {
                                toast.info(`Scheduling end time invalid.`, toastConfig);
                                errorCounter++;
                            }
                        break;
                    }
                break;
                case "Lights":
                    switch (rule.source) {
                        case "Light intensity":
                            min = 0;
                            max = 4095;
                            if(rule.treshold < min || rule.treshold > max) {
                                toast.info(`Light intensity treshold must be between ${min} and ${max}.`, toastConfig);
                                errorCounter++;
                            }
                        break;
                        case "Scheduled":
                            if(rule.start.minute < minMinute || rule.start.minute > maxMinute || rule.start.hour < minHour || rule.start.hour > maxHour) {
                                toast.info(`Scheduling start time invalid.`, toastConfig);
                                errorCounter++;
                            }
                            if(rule.end.minute < minMinute || rule.end.minute > maxMinute || rule.end.hour < minHour || rule.end.hour > maxHour) {
                                toast.info(`Scheduling end time invalid.`, toastConfig);
                                errorCounter++;
                            }
                        break;
                    }
                break;
            } 
        });
        if(errorCounter > 0) return false;
        else return true;
    }

    const updateRuleSource = (index, e) => {
        let data = [ ...rulesData ];      
        switch (data[index].action) {
            case "Watering":
                switch (e) {
                    case "Soil moisture":
                        data = data.map((rule, ruleIndex) => ruleIndex === index ? { action: "Watering", source: e} : rule);
                        break;
                    case "Scheduled":
                        data = data.map((rule, ruleIndex) => ruleIndex === index ? { 
                            action: "Watering",
                            source: e,
                            start: { hour: "00", minute: "00"}
                        } : rule);
                        break;
                        break;
                }
                break;
            case "Cooling":
                switch (e) {
                    case "Temperature":
                        data = data.map((rule, ruleIndex) => ruleIndex === index ? { action: "Cooling", source: e} : rule);
                        break;
                    case "Scheduled":
                        data = data.map((rule, ruleIndex) => ruleIndex === index ? { 
                            action: "Cooling",
                            source: e,
                            start: { hour: "00", minute: "00"},
                            end: { hour: "00", minute: "00"}
                        } : rule);
                        break;
                }
                break;
            case "Lights":
                switch (e) {
                    case "Light intensity":
                        data = data.map((rule, ruleIndex) => ruleIndex === index ? { action: "Lights", source: e} : rule);
                        break;
                    case "Scheduled":
                        data = data.map((rule, ruleIndex) => ruleIndex === index ? { 
                            action: "Lights",
                            source: e,
                            start: { hour: "00", minute: "00"},
                            end: { hour: "00", minute: "00"}
                        } : rule);
                        break;
                }
                break;
        }
        setRulesData(data);
    }

    const updateRuleAction = (index, e) => {
        let data = [ ...rulesData ];
        let selectedSource = e.toLowerCase();
        switch (e) {
            case "Watering":
                data = data.map((rule, ruleIndex) => ruleIndex === index ? { action: e, source: "Watering"} : rule);
                break;
            case "Cooling":
                data = data.map((rule, ruleIndex) => ruleIndex === index ? { action: e, source: "Cooling"} : rule);
                break;
            case "Lights":
                data = data.map((rule, ruleIndex) => ruleIndex === index ? { action: e, source: "Lights"} : rule);
                break;
        }
        data = data.map((rule, ruleIndex) => ruleIndex === index ? { ...rule, action: e, source: sources[selectedSource][0] } : rule);
        setRulesData(data);
    }

    const updateRuleStartHour = (index, e) => {
        let data = [ ...rulesData ];
        data = data.map((rule, ruleIndex) => ruleIndex === index ? { ...rule, start: { ...rule.start, hour: e} } : rule);
        setRulesData(data);
    }

    const updateRuleStartMinute = (index, e) => {
        let data = [ ...rulesData ];
        data = data.map((rule, ruleIndex) => ruleIndex === index ? { ...rule, start: { ...rule.start, minute: e} } : rule);
        setRulesData(data);
    }

    const updateRuleEndHour = (index, e) => {
        let data = [ ...rulesData ];
        data = data.map((rule, ruleIndex) => ruleIndex === index ? { ...rule, end: { ...rule.end, hour: e} } : rule);
        setRulesData(data);
    }

    const updateRuleEndMinute = (index, e) => {
        let data = [ ...rulesData ];
        data = data.map((rule, ruleIndex) => ruleIndex === index ? { ...rule, end: { ...rule.end, minute: e} } : rule);
        setRulesData(data);
    }

    const updateRuleAmount = (index, e) => {
        let data = [ ...rulesData ];
        data = data.map((rule, ruleIndex) => ruleIndex === index ? { ...rule, amount: e } : rule);
        setRulesData(data);
    }

    const updateRuleTreshold = (index, e) => {
        let data = [ ...rulesData ];
        data = data.map((rule, ruleIndex) => ruleIndex === index ? { ...rule, treshold: e.target.value } : rule);
        setRulesData(data);
    }

    const addRule = () => {
        let newRule = { action: "Watering", source: "Soil moisture" };
        setRulesData([ ...rulesData, newRule ]);
        console.log("ADD NEW RULE")
        console.log(JSON.stringify(newRule));
    }

    const deleteRule = (ruleIndex) => {
        let data = [ ...rulesData ];
        data = data.filter((rule, index) => index !== ruleIndex);
        setRulesData(data);
    }

    return (isClientSet ? <>
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Automation Rules</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                 {isLoading ? (<>
                    <Container className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden"></span>
                        </div>
                    </Container>
                </>) : (<>
                        {rulesData.length > 0 ? (<>
                            <Form className="pt-2 justify-content-end">
                            {rulesData.map((rule, index) => {   
                                return(<>
                                    <Form.Group as={Col} md="auto" className="mb-2">
                                        {/* <Row className="justify-content-center text-center align-items-center"> */}
                                        <Row className="justify-content-start">
                                            <Col lg={2} md={5} sm={5} xs={5} className="mb-1">
                                                <Form.Label as="span">Action:</Form.Label>
                                                <DropdownButton variant="success" title={rule.action} onSelect={e => updateRuleAction(index, e)} className="dropdown-action">
                                                    {actions.map(action => {
                                                        return(<>
                                                            <Dropdown.Item key={`${action}-${index}`} eventKey={action}>{action}</Dropdown.Item>
                                                        </>)
                                                    })}
                                                </DropdownButton>
                                            </Col>
                                            <Col lg={3} md={5} sm={5} xs={5} className="px-0 mb-1">
                                                <Form.Label as="span">Source:</Form.Label>
                                                <DropdownButton variant="success" title={rule.source} onSelect={e => updateRuleSource(index, e)} className="dropdown-source">
                                                    {rule.action === "Cooling" ? (<>
                                                        {
                                                            sources.cooling.map(source => {
                                                                return(<>
                                                                    <Dropdown.Item key={`${source}-${index}`} eventKey={source}>{source}</Dropdown.Item>
                                                                </>)
                                                            })
                                                        }
                                                    </>) : null }
                                                    {rule.action === "Watering" ? (<>
                                                        {
                                                            sources.watering.map(source => {
                                                                return(<>
                                                                    <Dropdown.Item key={`${source}-${index}`} eventKey={source}>{source}</Dropdown.Item>
                                                                </>)
                                                            })
                                                        }
                                                    </>) : null }
                                                    {rule.action === "Lights" ? (<>
                                                        {
                                                            sources.lights.map(source => {
                                                                return(<>
                                                                    <Dropdown.Item key={`${source}-${index}`} eventKey={source}>{source}</Dropdown.Item>
                                                                </>)
                                                            })
                                                        }
                                                    </>) : null }
                                                </DropdownButton>
                                            </Col>
                                            {rule.action === "Lights" && rule.source === "Light intensity" ?
                                            (<>
                                                <Col lg={3} md={5} sm={5} xs={5}  className="mb-1"></Col>
                                                <Col lg={3} md={5} sm={5} xs={5} className="mb-1">
                                                    <Form.Label as="span">Lower than: </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="treshold"
                                                        placeholder="Treshold (lux)"
                                                        min="0"
                                                        max="4095"
                                                        value={rule.treshold}
                                                        key={`treshold-${index}`}
                                                        onChange={e => updateRuleTreshold(index, e)}
                                                        className="treshold"
                                                    />
                                                </Col>
                                            </>) : null}
                                            {rule.action === "Cooling" && rule.source === "Temperature" ?
                                            (<>
                                                <Col lg={3} md={5} sm={5} xs={5}  className="mb-1"></Col>
                                                <Col lg={3} md={5} sm={5} xs={5} className="mb-1">
                                                    <Form.Label as="span">Higher than (℃): </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="treshold"
                                                        placeholder="Treshold (℃)"
                                                        min="0"
                                                        max="50"
                                                        value={rule.treshold}
                                                        key={`treshold-${index}`}
                                                        onChange={e => updateRuleTreshold(index, e)}
                                                        className="treshold"
                                                    />
                                                </Col>
                                            </>) : null}
                                            {(rule.action === "Cooling" || rule.action === "Lights") && rule.source === "Scheduled" ?
                                            (<>
                                                <Col lg={3} md={5} sm={5} xs={5}  className="mb-1">
                                                    <Form.Label as="span">Start time: </Form.Label>
                                                    <br/>
                                                    <DropdownButton variant="light" as={ButtonGroup} title={rule.start && rule.start.hour ? `${rule.start.hour}` : ""}  onSelect={e => updateRuleStartHour(index, e)}  className="time-dropdown">
                                                        {
                                                            hours.map(hour => {
                                                                return(<>
                                                                    <Dropdown.Item key={`start-hour-${hour}-${index}`} eventKey={hour}>{hour}</Dropdown.Item>
                                                                </>)
                                                            })
                                                        }
                                                    </DropdownButton>
                                                        <span className="mx-1 mt-1">:</span>
                                                    <DropdownButton variant="light" as={ButtonGroup} title={rule.start && rule.start.minute ? `${rule.start.minute}` : ""} onSelect={e => updateRuleStartMinute(index, e)}  className="time-dropdown">
                                                        {
                                                            minutes.map(minute => {
                                                                return(<>
                                                                    <Dropdown.Item key={`start-minute-${minute}-${index}`} eventKey={minute}>{minute}</Dropdown.Item>
                                                                </>)
                                                            })
                                                        }
                                                    </DropdownButton>
                                                </Col>
                                                <Col lg={3} md={5} sm={5} xs={5}  className="mb-1">
                                                    <Form.Label as="span">End time: </Form.Label>
                                                    <br/>
                                                    <DropdownButton variant="light" as={ButtonGroup} title={rule.end && rule.end.hour ? `${rule.end.hour}` : ""}  onSelect={e => updateRuleEndHour(index, e)}  className="time-dropdown">
                                                        {
                                                            hours.map(hour => {
                                                                return(<>
                                                                    <Dropdown.Item key={`end-hour-${hour}-${index}`} eventKey={hour}>{hour}</Dropdown.Item>
                                                                </>)
                                                            })
                                                        }
                                                    </DropdownButton>
                                                        <span className="mx-1 mt-1">:</span>
                                                    <DropdownButton variant="light" as={ButtonGroup} title={rule.end && rule.end.minute ? `${rule.end.minute}` : ""} onSelect={e => updateRuleEndMinute(index, e)}  className="time-dropdown">
                                                        {
                                                            minutes.map(minute => {
                                                                return(<>
                                                                    <Dropdown.Item key={`end-minute-${minute}-${index}`} eventKey={minute}>{minute}</Dropdown.Item>
                                                                </>)
                                                            })
                                                        }
                                                    </DropdownButton>
                                                </Col>
                                            </>) : null}
                                            { rule.action === "Watering" && rule.source === "Soil moisture" ?
                                            (<>
                                                <Col lg={3} md={5} sm={5} xs={5}  className="mb-1">
                                                    <Form.Label as="span">Lower than (%): </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="treshold"
                                                        min="0"
                                                        max="4095"
                                                        placeholder="Treshold (%)"
                                                        value={rule.treshold}
                                                        key={`treshold-${index}`}
                                                        onChange={e => updateRuleTreshold(index, e)}
                                                        className="treshold"
                                                    />
                                                </Col>
                                                <Col lg={3} md={5} sm={5} xs={5}  className="mb-1">
                                                <Form.Label as="span">Amount (ml): </Form.Label>
                                                    <DropdownButton variant="light" title={rule.amount ? `${rule.amount} ml` : ""}  onSelect={e => updateRuleAmount(index, e)}  className="amount">
                                                        {
                                                            wateringAmounts.map(amount => {
                                                                return(<>
                                                                    <Dropdown.Item key={`amount-${index}`} eventKey={amount}>{amount} ml</Dropdown.Item>
                                                                </>)
                                                            })
                                                        }
                                                    </DropdownButton>
                                                </Col>
                                            </>) : null}
                                            {rule.action === "Watering" && rule.source === "Scheduled" ?
                                            (<>
                                                <Col lg={3} md={5} sm={5} xs={5}  className="mb-1">
                                                    <Form.Label as="span">Start time: </Form.Label>
                                                    <br/>
                                                    <DropdownButton variant="light" as={ButtonGroup} title={rule.start && rule.start.hour ? `${rule.start.hour}` : ""}  onSelect={e => updateRuleStartHour(index, e)}  className="time-dropdown">
                                                        {
                                                            hours.map(hour => {
                                                                return(<>
                                                                    <Dropdown.Item key={`start-hour-${hour}-${index}`} eventKey={hour}>{hour}</Dropdown.Item>
                                                                </>)
                                                            })
                                                        }
                                                    </DropdownButton>
                                                        <span className="mx-1 mt-1">:</span>
                                                    <DropdownButton variant="light" as={ButtonGroup} title={rule.start && rule.start.minute ? `${rule.start.minute}` : ""} onSelect={e => updateRuleStartMinute(index, e)}  className="time-dropdown">
                                                        {
                                                            minutes.map(minute => {
                                                                return(<>
                                                                    <Dropdown.Item key={`start-minute-${minute}-${index}`} eventKey={minute}>{minute}</Dropdown.Item>
                                                                </>)
                                                            })
                                                        }
                                                    </DropdownButton>
                                                </Col>
                                                <Col lg={3} md={5} sm={5} xs={5}  className="mb-1">
                                                    <Form.Label as="span">Amount (ml): </Form.Label>
                                                    <DropdownButton variant="light" title={rule.amount ? `${rule.amount} ml` : ""}  onSelect={e => updateRuleAmount(index, e)}  className="amount">
                                                        {
                                                            wateringAmounts.map(amount => {
                                                                return(<>
                                                                    <Dropdown.Item key={`amount-${index}`} eventKey={amount}>{amount} ml</Dropdown.Item>
                                                                </>)
                                                            })
                                                        }
                                                    </DropdownButton>
                                                </Col>
                                            </>) : null}
                                            <Col xs="auto" className="mb-1 d-flex align-items-center">
                                                <Button key={`close-${index}`} className="btn-close" aria-label="Close" onClick={() => deleteRule(index)}></Button>
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                    <hr/>
                                </>)
                            })}
                            </Form>
                        </>) : (<>
                            <h4 className="mx-auto text-center">No rules set.</h4>
                        </>)}
                    <Container className="d-flex justify-content-end mt-2">
                        <Button variant="dark" size="sm" className="btn-custom" onClick={addRule}>
                            <Container className='d-flex align-items-center px-0'>
                                <FaPlusCircle/> New rule
                            </Container>
                        </Button>
                    </Container>
                </>)}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="success" onClick={updateRules} disabled={isLoading}>
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
        <Button variant="success" className="btn-lg" onClick={handleShow}>
            <Container className='d-flex align-items-center px-0'>
                <FaWrench/> Setup rules
            </Container>
         </Button>
    </> : null)
}
export default Rules;